const flags = {
  'true': 'Habilitadas',
  'false': 'Deshabilitadas'
}

const getFlagName = i => (
  flags[i]
)

export { flags, getFlagName }